<template>
  <section>
    <v-flex wrap style="padding: 10px;">
      <v-btn style="float:right;" @click="OpenCourseModal">Add Course SEO</v-btn>
    </v-flex>
    <app-add-course-seo ref="GetDetails" :dialog="AddCourseSEODialog" @close="CloseCourseModal"></app-add-course-seo>
    <app-course-seo-table></app-course-seo-table>
  </section>
</template>
<script>
import appAddCourseSeo from "../views/dialogs/AddCourseSEO";
import appCourseSeoTable from "../views/tables/CourseSEO";
export default {
  components: {
    appAddCourseSeo,
    appCourseSeoTable
  },
  data() {
    return {
      AddCourseSEODialog: false
    };
  },
  methods: {
    OpenCourseModal() {
      this.$refs.GetDetails.GetCourseDetailsList();
      this.AddCourseSEODialog = true;
    },
    CloseCourseModal() {
      this.AddCourseSEODialog = false;
    }
  },
  mounted(){
    this.$eventHub.$emit("LOADING",'false')
  }
};
</script>
<style scoped>
</style>